<template>
  <div class="teaser">
    <div class="outer" v-for="(teaser, index) in teasers" :class="( teaser.class )">
      <div class="inner">
        <h1 v-html="teaser.title"></h1>
        <p class="sub-title" v-if="teaser.subtitle">{{teaser.subtitle}}</p>
        <div class="icons">
          <p class="italic">Track record:</p>
          <div>
            <img src="../assets/images/retail-icon.png" alt="retail"/>
            <p>Retail</p>
          </div>
          <div>
            <img src="../assets/images/foodservice-icon.png" alt="foodservice"/>
            <p>Foodservice</p>
          </div>
          <div>
            <img src="../assets/images/petrol-icon.png" alt="petrol"/>
            <p>Petrol</p>
          </div>
        </div>
        <img v-bind:src="teaser.image"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { deliveryClient } from '@/kontent.js'

  export default {
    name: 'teaser',
    data: function() {
      return {
        teasers: []
      }
    },
    props: {
      pagename: String
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('teaser')
      .containsFilter('elements.sitemap', [this.pagename])
      .toPromise()
      .then(response => {
        this.$data.teasers = response.items.map(item => ({
          title: item.titel.value,
          subtitle: item.ondertitel.value,
          image: item.afbeelding.value[0].url
        }))

      })
    }
  }
</script>
